import { platformUiReducer } from './reducer';

export const rootReducer = platformUiReducer;

export const rootReducerStateKey = 'platform-ui';
